import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export class UploadResponse {
  progress: number;
  files: [];
}

@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  showDescription: boolean = false;
  isDisabled: boolean = false;
  fileSize: boolean = false;
  files: any[] = [];
  upload: UploadResponse = new UploadResponse();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<FileUploadComponent>) { }

  ngOnInit(): void {
    this.showDescription = this.data ? this.data.showDescription : false;
  }

  fileBrowseHandler(files: any) {
    this.prepareFilesList(files);
  }
  onFileDropped(files: any) {
    this.prepareFilesList(files);
  }
  prepareFilesList(files: Array<any>) {
    if (this.validateFileSize(files)) {
      return;
    } else {
      for (const item of files) {
        item.progress = 0;
        this.files.push(item);
      }
      this.uploadFilesSimulator(0);
    }
  }
  onDeleteFile(index: number) {
    this.files.splice(index, 1);
  }
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        this.isDisabled = true;
        return;
      } else {
        this.isDisabled = false;
        const progressInterval = setInterval(() => {
          if (this.files[index]?.progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }
  onDroppedFile(droppedFiles: any) {
    let formData = new FormData();
    for (let item of droppedFiles) {
      formData.append('userfiles', item)
    }
    this._dialogRef.close(droppedFiles);
  }
  validateFileSize(fileObj: any): boolean {
    this.fileSize = (fileObj[0].size / 1024 / 1024) > 15 ? true : false;
    return this.fileSize;
  }

  onCancel() {
    this._dialogRef.close('Cancel');
  }

}
